import styled from "styled-components";

import { DashboardLoader } from "app/components/React/DashboardLoader";

export const StyledDashboardLoader = styled(DashboardLoader)`
    width: 100%;
    left: 0;
`;
